export const TaskTypeNameAddGeneralDentistToSendNewPatientReferralTo =
  "add_general_dentist_to_send_new_patient_referral_to";
